namespace Q {
    export namespace Culture {
        export let name = "english";
        export let shortName = "en";
        export let country = "US";
        export let language = `${shortName}-${country}`;
        export let decimalSeparator = ".";
        export let dateSeparator = "/";
        export let dateOrder = "dmy";
        export let commonDateOrder: string;
        export let dateFormat = "dd/MM/yyyy";
        export let commonDateFormat: string;
        export let dateTimeFormat = "dd/MM/yyyy HH:mm:ss";
        export let commonDateTimeFormat: string;

        export function get_groupSeparator(): string {
            return ((decimalSeparator === ",") ? "." : ",");
        }

        /*if (document.documentElement.lang) {
            const lang = document.documentElement.lang.split("-");

            if (lang.length === 2) {
                shortName = lang[0].toLowerCase();
                country = lang[1].toUpperCase();
            } else if (lang.length === 1) {
                shortName = lang[0].toLowerCase();
            }
        }*/

        const s = Q.trimToNull($("script#ScriptCulture").html());

        if (s != null) {
            let sc = JSON.parse(s);
            sc = $.extend(true, {}, sc, cultureAdditional(sc, true));

            if (sc.Name) {
                name = sc.Name;
            }

            if (sc.ShortName) {
                shortName = sc.ShortName;
            }

            if (sc.Language) {
                language = sc.Language;

                let languageArray = language.split("-");

                if (languageArray[1]) {
                    country = languageArray[1].trim().toUpperCase();
                }
            }

            if (sc.DecimalSeparator) {
                decimalSeparator = sc.DecimalSeparator;
            }

            if (sc.DateSeparator) {
                dateSeparator = sc.DateSeparator;
            }

            if (sc.DateOrder) {
                dateOrder = sc.DateOrder;
            }

            if (sc.DateFormat) {
                dateFormat = sc.DateFormat;
            }

            if (sc.DateTimeFormat) {
                dateTimeFormat = sc.DateTimeFormat;
            }

            // const addtionalData = cultureAdditional(sc, language, country);

            // if (addtionalData) {
            //     if (addtionalData.commonDateOrder) {
            //         commonDateOrder = addtionalData.commonDateOrder;
            //     }
            //
            //     if (addtionalData.commonDateFormat) {
            //         commonDateFormat = addtionalData.commonDateFormat;
            //     }
            //
            //     if (addtionalData.commonDateTimeFormat) {
            //         commonDateTimeFormat = addtionalData.commonDateTimeFormat;
            //     }
            // }
        }
    }

    export function formatNumber(n: number, fmt: string, dec?: string, grp?: string): string {
        let neg = "-";

        if (isNaN(n)) {
            return null;
        }

        dec = dec || Culture.decimalSeparator;
        grp = grp || Culture.get_groupSeparator();

        let r = "";

        if (fmt.indexOf(".") > -1) {
            let dp = dec,
                df = fmt.substring(fmt.lastIndexOf(".") + 1);
            n = roundNumber(n, df.length);
            let dv = n % 1,
                ds = String(dv.toFixed(df.length));
            ds = ds.substring(ds.lastIndexOf(".") + 1);

            for (let i = 0, len = df.length; i < len; i++) {
                if (df.charAt(i) === "#" && ds.charAt(i) != "0") {
                    dp += ds.charAt(i);
                } else if (df.charAt(i) === "#" && ds.charAt(i) == "0") {
                    let notParsed = ds.substring(i);

                    if (notParsed.match("[1-9]")) {
                        dp += ds.charAt(i);
                    } else {
                        break;
                    }
                } else if (df.charAt(i) == "0") {
                    dp += ds.charAt(i);
                } else {
                    dp += df.charAt(i);
                }
            }

            r += dp;
        } else {
            n = Math.round(n);
        }

        let ones = Math.floor(n);

        if (n < 0) {
            ones = Math.ceil(n);
        }

        let of = "";

        if (fmt.indexOf(".") == -1) {
            of = fmt;
        } else {
            of = fmt.substring(0, fmt.indexOf("."));
        }

        let op = "";

        if (!(ones == 0 && of.substr(of.length - 1) === "#")) {
            // find how many digits are in the group
            let oneText = String(Math.abs(ones)),
                gl = 9999;

            if (of.lastIndexOf(",") != -1) {
                gl = of.length - of.lastIndexOf(",") - 1;
            }

            let gc = 0;

            for (let i = oneText.length - 1; i > -1; i--) {
                op = oneText.charAt(i) + op;
                gc++;

                if (gc == gl && i != 0) {
                    op = grp + op;
                    gc = 0;
                }
            }

            // account for any pre-data padding
            if (of.length > op.length) {
                let padStart = of.indexOf("0");

                if (padStart != -1) {
                    let padLen = of.length - padStart;
                    // pad to left with 0's or group char
                    let pos = of.length - op.length - 1;

                    while (op.length < padLen) {
                        let pc = of.charAt(pos);

                        // replace with real group char if needed
                        if (pc === ",") {
                            pc = grp;
                        }

                        op = pc + op;
                        pos--;
                    }
                }
            }
        }

        if (!op && of.indexOf("0", of.length - 1) !== -1) {
            op = "0";
        }

        r = op + r;

        if (n < 0) {
            r = neg + r;
        }

        if (r.lastIndexOf(dec) === r.length - 1) {
            r = r.substring(0, r.length - 1);
        }

        return r;
    }

    export function parseInteger(s: string): number {
        s = trim(s.toString());
        let ts = Culture.get_groupSeparator();

        if (s && s.length && s.indexOf(ts) > 0) {
            s = s.replace(new RegExp("(\\b\\d{1,3})\\" + ts + "(?=\\d{3}(\\D|$))", "g"), "$1");
        }

        if (!(/^[-\+]?\d+$/.test(s))) {
            return NaN;
        }

        return parseInt(s, 10);
    }

    export function parseDecimal(s: string): number {
        if (s == null) {
            return null;
        }

        s = trim(s.toString());

        if (s.length === 0) {
            return null;
        }

        let ts = Culture.get_groupSeparator();

        if (s && s.length && s.indexOf(ts) > 0) {
            s = s.replace(new RegExp("(\\b\\d{1,3})\\" + ts + "(?=\\d{3}(\\D|$))", "g"), "$1");
        }

        if (!(new RegExp("^\\s*([-\\+])?(\\d*)\\" + Culture.decimalSeparator + "?(\\d*)\\s*$").test(s))) {
            return NaN;
        }

        return parseFloat(s.toString().replace(Culture.decimalSeparator, "."));
    }

    function roundNumber(n: number, dec?: number): number {
        let power = Math.pow(10, dec || 0),
            value = (Math.round(n * power) / power).toString();

        // ensure the decimal places are there
        if (dec > 0) {
            let dp = value.indexOf(".");

            if (dp == -1) {
                value += ".";
                dp = 0;
            } else {
                dp = value.length - (dp + 1);
            }

            while (dp < dec) {
                value += "0";
                dp++;
            }
        }

        return parseFloat(value);
    }

    export function toId(id: any): any {
        if (id == null) {
            return null;
        }

        if (typeof id === "number") {
            return id;
        }

        id = $.trim(id);

        if (id == null || !id.length) {
            return null;
        }

        if (id.length >= 15 || !(/^-?\d+$/.test(id))) {
            return id;
        }

        let v = parseInt(id, 10);

        if (isNaN(v)) {
            return id;
        }

        return v;
    }

    export function formatDate(d: Date | string, format?: string, keepLocale: boolean = false, calendar: string = undefined) {
        if (!d) {
            return "";
        }
        calendar = calendar || Q.Culture.name;
        const customCalendar = (Culture.name !== "english" && $.calendars) ? $.calendars.instance(calendar, Culture.shortName) : null;
        let date: Date;

        if (typeof d === "string") {
            const res = Q.parseDate(d);

            if (!res) {
                return d;
            }

            /* <Validate year> */
            const year = (res as Date).getFullYear();

            if (year < 1753 || year > 9999) {
                let time = null;
                const trimmedDate = d.replace(/T.*/, (match: any): string => {
                        time = (match as string).substring(1);

                        return "";
                    }),
                    dArray: any = splitDateString(trimmedDate),
                    tArray: Array<string> | null = (time) ? (time as string).split(/[:.]/) : null;

                if (!dArray || dArray.length !== 3) {
                    return d;
                }

                let year: number,
                    month: number,
                    day: number;

                switch ((Culture.commonDateOrder || Culture.dateOrder)) {
                    case "dmy":
                        year = +dArray[2];
                        month = +dArray[1];
                        day = +dArray[0];

                        break;
                    case "ymd":
                        year = +dArray[0];
                        month = +dArray[1];
                        day = +dArray[2];

                        break;
                    case "mdy":
                    default:
                        year = +dArray[2];
                        month = +dArray[0];
                        day = +dArray[1];

                        break;
                }

                if ((!isNaN(year) && !isNaN(month) && !isNaN(day)) && ((year > 0 && year < 9999) && (month >= 1 && month <= 12) && (day >= 1 && day <= 31))) {
                    date = customCalendar.toJSDate(year, month, day);

                    if (tArray && tArray.length) {
                        date.setHours(+tArray[0]);

                        if (tArray[1]) {
                            date.setMinutes(+tArray[1]);
                        }

                        if (tArray[2]) {
                            date.setSeconds(+tArray[2]);
                        }

                        if (tArray[3]) {
                            date.setMilliseconds(+tArray[3]);
                        }
                    }

                    /* Prevent to re-format generated date */
                    keepLocale = true;
                } else {
                    return d;
                }
            }
            /* </Validate year> */
            else {
                date = res as Date;
            }
        } else {
            date = d;
        }

        if (format == null || format === "d") {
            format = Culture.commonDateFormat || Culture.dateFormat;
        } else {
            switch (format) {
                case "g":
                    format = (Culture.commonDateTimeFormat || Culture.dateTimeFormat).replace(":ss", "");

                    break;
                case "G":
                    format = Culture.commonDateTimeFormat || Culture.dateTimeFormat;

                    break;
                case "s":
                    format = "yyyy-MM-ddTHH:mm:ss";

                    break;
                case "u":
                    return Q.formatISODateTimeUTC(date);
            }
        }

        let pad = function (i: number) {
            return Q.zeroPad(i, 2);
        };

        if (!keepLocale && customCalendar) {
            let CDate = customCalendar.fromJSDate(date),
                reFormat = format.replace(new RegExp("dd?|MM?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|fff|zz?z?|\\/", "g"), (string): any => {
                    switch (string) {
                        case "/":
                            return Culture.dateSeparator;

                        case "MM":
                            return "mm";

                        case "H":
                        case "HH":
                        case "m":
                        case "mm":
                        case "s":
                        case "ss":
                            return `[${string}]`;

                        // case "zzz":
                        // case "zz":
                        // case "z":
                        //     return "";

                        default:
                            return string;
                    }
                });

            // @ts-ignore
            return CDate.formatDate(reFormat.replace(/\[.*?\]/g, function (string) {
                let temp,
                    padding = false;

                switch (string) {
                    case "[H]":
                    case "[HH]":
                        temp = date.getHours();

                        break;
                    case "[m]":
                    case "[mm]":
                        temp = date.getMinutes();

                        break;
                    case "[s]":
                    case "[ss]":
                        temp = date.getSeconds();

                        break;
                    default:
                        return "";
                }

                if (string === "[HH]" || string === "[mm]" || string === "[ss]") {
                    padding = true;
                }

                return (padding) ? pad(temp) : temp;
            }));
        }

        return format.replace(new RegExp("dd?|MM?|yy?y?y?|hh?|HH?|mm?|ss?|tt?|fff|zz?z?|\\/", "g"),
            function (fmt): any {
                switch (fmt) {
                    case "/":
                        return Culture.dateSeparator;

                    case "hh":
                        return pad(((date.getHours() < 13) ? date.getHours() : (date.getHours() - 12)));

                    case "h":
                        return (date.getHours() < 13) ? date.getHours() : (date.getHours() - 12);

                    case "HH":
                        return pad(date.getHours());

                    case "H":
                        return date.getHours();

                    case "mm":
                        return pad(date.getMinutes());

                    case "m":
                        return date.getMinutes();

                    case "ss":
                        return pad(date.getSeconds());

                    case "s":
                        return date.getSeconds();

                    case "yyyy":
                        return date.getFullYear();

                    case "yy":
                        return date.getFullYear().toString().substr(2, 4);

                    case "dd":
                        return pad(date.getDate());

                    case "d":
                        return date.getDate().toString();

                    case "MM":
                        return pad(date.getMonth() + 1);

                    case "M":
                        return date.getMonth() + 1;

                    case "t":
                        return (date.getHours() < 12) ? "A" : "P";

                    case "tt":
                        return (date.getHours() < 12) ? "AM" : "PM";

                    case "fff":
                        return Q.zeroPad(date.getMilliseconds(), 3);

                    case "zzz":
                    case "zz":
                    case "z":
                        return "";

                    default:
                        return fmt;
                }
            }
        );
    }

    export function formatDayHourAndMin(n: number): string {
        if (n === 0) {
            return "0";
        } else if (!n) {
            return "";
        }

        let days = Math.floor(n / 24 / 60);
        let txt = "";

        if (days > 0) {
            txt += days.toString();
        }

        let mins = zeroPad(Math.floor((n % (24 * 60)) / (60)), 2) + ":" + zeroPad(n % 60, 2);

        if (mins != "00:00") {
            if (days > 0) {
                txt += ".";
            }

            txt += mins;
        }

        return txt;
    }

    export function formatISODateTimeUTC(d: Date): string {
        if (d == null) {
            return "";
        }

        let zeropad = function (num: number) {
            return ((num < 10) ? '0' : '') + num;
        };
        let str = d.getUTCFullYear() + "-" +
            zeropad(d.getUTCMonth() + 1) + "-" +
            zeropad(d.getUTCDate()) + "T" +
            zeropad(d.getUTCHours()) + ":" +
            zeropad(d.getUTCMinutes());
        let secs = Number(d.getUTCSeconds() + "." +
            ((d.getUTCMilliseconds() < 100) ? "0" : "") +
            zeropad(d.getUTCMilliseconds()));
        str += ":" + zeropad(secs) + "Z";

        return str;
    }

    let isoRegexp = /(\d{4,})(?:-(\d{1,2})(?:-(\d{1,2})(?:[T ](\d{1,2}):(\d{1,2})(?::(\d{1,2})(?:\.(\d+))?)?(?:(Z)|([+-])(\d{1,2})(?::(\d{1,2}))?)?)?)?)?/;

    export function parseISODateTime(s: string): Date {
        if (!s) {
            return null;
        }

        s = `${s}`;

        if (!s.length) {
            return null;
        }

        let res = s.match(isoRegexp);

        if (typeof res === "undefined" || res === null) {
            return null;
        }

        let year: number,
            month: number,
            day: number,
            hour: number,
            min: number,
            sec: number,
            msec: number;
        year = parseInt(res[1], 10);

        if (typeof res[2] === "undefined" || res[2] === "") {
            return new Date(year);
        }

        month = parseInt(res[2], 10) - 1;
        day = parseInt(res[3], 10);

        if (typeof res[4] === "undefined" || res[4] === "") {
            return new Date(year, month, day);
        }

        hour = parseInt(res[4], 10);
        min = parseInt(res[5], 10);
        sec = (typeof res[6] !== "undefined" && res[6] !== "") ? parseInt(res[6], 10) : 0;

        if (typeof res[7] !== "undefined" && res[7] !== "") {
            msec = Math.round(1000.0 * parseFloat(`0.${res[7]}`));
        } else {
            msec = 0;
        }

        if ((typeof res[8] === "undefined" || res[8] === "") && (typeof res[9] === "undefined" || res[9] === "")) {
            return new Date(year, month, day, hour, min, sec, msec);
        }

        let ofs: number;

        if (typeof res[9] !== "undefined" && res[9] !== "") {
            ofs = parseInt(res[10], 10) * 3600000;

            if (typeof res[11] !== "undefined" && res[11] !== "") {
                ofs += parseInt(res[11], 10) * 60000;
            }

            if (res[9] === "-") {
                ofs = -ofs;
            }
        } else {
            ofs = 0;
        }

        return new Date(Date.UTC(year, month, day, hour, min, sec, msec) - ofs);
    }

    export function parseHourAndMin(value: string) {
        const v = trim(value);

        if (v.length < 4 || v.length > 5) {
            return NaN;
        }

        let h: number,
            m: number;

        if (v.charAt(1) === ":") {
            h = parseInteger(v.substr(0, 1));
            m = parseInteger(v.substr(2, 2));
        } else {
            if (v.charAt(2) !== ":") {
                return NaN;
            }

            h = parseInteger(v.substr(0, 2));
            m = parseInteger(v.substr(3, 2));
        }

        if (isNaN(h) || isNaN(m) || h < 0 || h > 23 || m < 0 || m > 59) {
            return NaN;
        }

        return h * 60 + m;
    }

    export function parseDayHourAndMin(s: string): number {
        let days: number,
            v = trim(s);

        if (!v) {
            return NaN;
        }

        let p = v.split(".");

        if (p.length === 0 || p.length > 2) {
            return NaN;
        }

        if (p.length == 1) {
            days = parseInteger(p[0]);

            if (!isNaN(days)) {
                return days * 24 * 60;
            }

            return parseHourAndMin(p[0]);
        } else {
            days = parseInteger(p[0]);
            let hm = parseHourAndMin(p[1]);

            if (isNaN(days) || isNaN(hm)) {
                return NaN;
            }

            return days * 24 * 60 + hm;
        }
    }

    export function parseDate(s: string, dateOrder?: string): any {
        if (!s || !s.length) {
            return null;
        }

        if (s.length >= 10 && s.charAt(4) === "-" && s.charAt(7) === "-" && (s.length === 10 || (s.length > 10 && s.charAt(10) === "T"))) {
            var res = Q.parseISODateTime(s);

            if (res == null) {
                return false;
            }

            return res;
        }

        let dateVal: any,
            dArray: any,
            d: number,
            m: number,
            y: number;
        dArray = splitDateString(s);

        if (!dArray) {
            return false;
        }

        if (dArray.length === 3) {
            dateOrder = dateOrder || Culture.commonDateOrder || Culture.dateOrder;

            switch (dateOrder) {
                case "dmy":
                    d = parseInt(dArray[0], 10);
                    m = parseInt(dArray[1], 10) - 1;
                    y = parseInt(dArray[2], 10);

                    break;
                case "ymd":
                    d = parseInt(dArray[2], 10);
                    m = parseInt(dArray[1], 10) - 1;
                    y = parseInt(dArray[0], 10);

                    break;
                case "mdy":
                default:
                    d = parseInt(dArray[1], 10);
                    m = parseInt(dArray[0], 10) - 1;
                    y = parseInt(dArray[2], 10);

                    break;
            }

            if (isNaN(d) || isNaN(m) || isNaN(y) || d < 1 || d > 31 || m < 0 || m > 11 || y > 9999 || y < 0) {
                return false;
            }

            if (y < 100) {
                let fullYear = new Date().getFullYear();
                let shortYearCutoff = (fullYear % 100) + 10;
                y += fullYear - fullYear % 100 + (y <= shortYearCutoff ? 0 : -100);
            }

            try {
                dateVal = new Date(y, m, d);

                if (isNaN(dateVal.getFullYear())) {
                    return false;
                }
            } catch (e) {
                return false;
            }
        } else if (dArray.length === 1) {
            try {
                dateVal = new Date(dArray[0]);

                if (isNaN(dateVal.getFullYear())) {
                    return false;
                }
            } catch (e) {
                return false;
            }
        }

        return dateVal;
    }

    export function splitDateString(s: string): string[] {
        s = trim(s);

        if (!s.length) {
            return;
        }

        if (s.indexOf("/") >= 0) {
            return s.split("/");
        } else if (s.indexOf(".") >= 0) {
            return s.split(".");
        } else if (s.indexOf("-") >= 0) {
            return s.split("-");
        } else if (s.indexOf("\\") >= 0) {
            return s.split("\\");
        } else {
            return [s];
        }
    }

    function cultureAdditional(culture: any, overwrite: boolean = false) {
        if (!culture || typeof culture !== "object" || !culture.Language) {
            return;
        }

        const PREFIX = (overwrite === true) ? "" : "common";
        let addtionalData: any = {};

        switch (culture.Language) {
            case "fa-IR":
                addtionalData[`${PREFIX}DateOrder`] = Q.reverseText(culture.DateOrder);
                addtionalData[`${PREFIX}DateFormat`] = Q.reverseText(culture.DateFormat);
                addtionalData[`${PREFIX}DateTimeFormat`] = "yyyy/MM/dd HH:mm:ss";

                break;
        }

        return (Object.keys(addtionalData).length) ? addtionalData : undefined;
    }
}